module.exports = __webpack_public_path__ + "static/media/autor.a9401df0.png";